import { render } from "./giftItemMobileDetail.vue?vue&type=template&id=48a6d365&scoped=true"
import script from "./giftItemMobileDetail.vue?vue&type=script&lang=js"
export * from "./giftItemMobileDetail.vue?vue&type=script&lang=js"

import "./giftItemMobileDetail.vue?vue&type=style&index=0&id=48a6d365&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a6d365"]])

export default __exports__